/* Product marketing area helpers (snippets/cq-product-marketing.liquid, snippets/cq-pm-story.liquid). Runs after the
   product tabs script. The area renders only for a product with story entries, so these are the story's helpers:
   1. Description tab: each top heading starts a section for spacing; sections that repeat the marketing area (block
      setting "Description sections to hide") are hidden; one real photo joins "What you are looking at".
   2. Story chapters: the before and after slider, What's inside (accordion and dish zoom), How it's built (the pinned
      frame), What it reduces, Fit and care sizes (a radio group tied to the buy box), headline reveals, image fades.
   3. The info index on desktop (crossfading panels, sliding dot, Overview first) and the phone accordions.
   4. Starts the page bars of every product page (assets/cq-product-bar.js) with Overview and the desktop index.
   Round 14 (2026-10-24): the earlier layouts' helpers (Look closer, the word-by-word statement, the long page, the
   section bar, story pins, callout zooms, the first What it reduces and capacity bars) were removed with their markup. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function tabFor(root, test) {
    var buttons = root.querySelectorAll('.pdp-tab-part .tablinks');
    for (var i = 0; i < buttons.length; i++) {
      if (test.test(buttons[i].textContent)) {
        var id = buttons[i].getAttribute('aria-controls') || buttons[i].dataset.tab;
        return { button: buttons[i], panel: document.getElementById(id), id: id };
      }
    }
    return null;
  }

  /* The tabs script moves content between the desktop panel and the phone accordion; write into whichever holds it. */
  function contentBox(root, tab) {
    if (!tab || !tab.panel) return null;
    var desktop = tab.panel.querySelector('[data-cq-description-desktop]');
    if (!desktop) return tab.panel;
    var key = desktop.getAttribute('data-cq-description-desktop');
    var mobile = root.querySelector('[data-cq-description-mobile="' + key + '"]');
    if (mobile && mobile.childNodes.length && !desktop.childNodes.length) return mobile;
    return desktop;
  }

  function styleDescription(root, band, page) {
    var tab = tabFor(root, /description/i);
    var box = contentBox(root, tab);
    if (!box) return;
    /* Story pages (round 11) also hide the sections the story now tells: the Description reads as an overview and
       questions. The hidden text stays in the page source. */
    var list = (page && page.dataset.hide ? page.dataset.hide : '');
    if (band.classList.contains('cqpm--r8') && band.dataset.hideStory) list += '|' + band.dataset.hideStory;
    var hide = list.split('|').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    var figureTpl = band.querySelector('template[data-cqpm-figure]');
    box.classList.add('cqd');
    var heads = Array.prototype.filter.call(box.children, function (el) { return el.tagName === 'H3'; });
    heads.forEach(function (h) {
      var sec = document.createElement('section');
      sec.className = 'cqd-sec';
      h.parentNode.insertBefore(sec, h);
      var next = h;
      while (next && (next === h || next.tagName !== 'H3')) {
        var after = next.nextElementSibling;
        sec.appendChild(next);
        next = after;
      }
      h.classList.add('cqd-head');
      var title = h.textContent.trim().toLowerCase();
      if (hide.indexOf(title) !== -1) sec.hidden = true;
      if (figureTpl && /looking at/i.test(title)) {
        sec.classList.add('cqd-sec--figure');
        sec.insertBefore(figureTpl.content.cloneNode(true), h.nextSibling);
        figureTpl = null;
      }
    });
  }

  function hdrH() { var h = document.querySelector('header#header'); return h ? h.offsetHeight : 72; }
  function headerBottom() {
    var header = document.querySelector('sticky-header, .header-wrapper, header');
    if (!header) return 0;
    return Math.max(0, Math.min(header.getBoundingClientRect().bottom, 140));
  }
  function norm(v) { return String(v || '').replace(/[\u201c\u201d\u2033]/g, '"').trim(); }

  /* Before and after: a native range input drives the divider, so keyboard arrows, touch and screen readers work. */
  function compares(band) {
    band.querySelectorAll('[data-cqpm-cmp]').forEach(function (box) {
      var range = box.querySelector('.cqpm-cmp-range');
      var set = function () { box.style.setProperty('--pos', range.value + '%'); };
      /* Dragging follows the finger exactly; a tap or a key press glides to the new spot. */
      range.addEventListener('pointerdown', function () { box.classList.add('is-dragging'); });
      ['pointerup', 'pointercancel', 'blur'].forEach(function (ev) { range.addEventListener(ev, function () { box.classList.remove('is-dragging'); }); });
      range.addEventListener('input', set);
      /* Round 11: each label fades as the divider passes it, so a label never sits on the other photo. */
      var lb = box.querySelector('.cqpm-cmp-label--before'), la = box.querySelector('.cqpm-cmp-label--after');
      if (lb && la) range.addEventListener('input', function () { var v = +range.value; lb.classList.toggle('is-off', v < 30); la.classList.toggle('is-off', v > 70); });
      set();
    });
  }


  /* ===== Round 8 (snippets/cq-pm-story.liquid, Direction A port). Every interactive panel reserves the height of its
     tallest state, so choosing never moves the page. ===== */
  function onResize(fn) {
    var t = null, w = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === w) return;
      w = window.innerWidth;
      clearTimeout(t); t = setTimeout(fn, 150);
    });
  }

  /* Round 14 (2026-10-25): work a section only needs once it is about to be seen (measuring its tallest state, placing a
     marker) waits until the section is within a screen of view, so it stays out of the page's first load. A section
     that is never shown (the desktop index on a phone) never pays for it. */
  function whenNear(el, fn) {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (es) {
      if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); fn(); }
    }, { rootMargin: '100% 0px 100% 0px' });
    io.observe(el);
  }

  /* The tallest of several states of one element, measured in one layout pass: a hidden copy per state, all read
     together (reading the element itself after each change forced a fresh layout of the page every time). */
  function tallest(el, states, apply) {
    var w = el.getBoundingClientRect().width;
    var copies = states.map(function (s) {
      apply(s);
      var c = el.cloneNode(true);
      c.removeAttribute('id');
      c.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
      c.setAttribute('aria-hidden', 'true');
      c.style.cssText = 'position:absolute;left:0;top:0;box-sizing:border-box;width:' + w + 'px;min-height:0;visibility:hidden;pointer-events:none';
      return c;
    });
    copies.forEach(function (c) { el.parentNode.appendChild(c); });
    var max = 0;
    copies.forEach(function (c) { max = Math.max(max, c.offsetHeight); });
    copies.forEach(function (c) { c.remove(); });
    return max;
  }

  /* "What's inside": one numbered line open at a time; the list keeps the height of its tallest state. */
  function accordion8(band) {
    band.querySelectorAll('[data-cqs-acc]').forEach(function (box) {
      var ol = box.querySelector('ol');
      var items = Array.prototype.slice.call(ol.children);
      if (!items.length) return;
      box.classList.add('is-js');
      function open(li) {
        items.forEach(function (x) {
          var on = x === li;
          x.classList.toggle('is-open', on);
          x.querySelector('button').setAttribute('aria-expanded', on ? 'true' : 'false');
        });
      }
      function reserve() {
        var cur = items.filter(function (x) { return x.classList.contains('is-open'); })[0] || items[0];
        var max = tallest(ol, items, open);
        open(cur);
        ol.style.minHeight = max + 'px';
      }
      box.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b || !ol.contains(b)) return;
        /* Round 11: closing the open row above would pull the tapped row up; keep it where the finger is. */
        var stacked = window.matchMedia('(max-width: 749px)').matches;
        var t0 = b.getBoundingClientRect().top;
        open(b.parentNode);
        var dt = b.getBoundingClientRect().top - t0;
        if (stacked && Math.abs(dt) > 1) window.scrollBy({ top: dt, behavior: 'instant' });
      });
      whenNear(box, function () { reserve(); onResize(reserve); });
    });
  }

  /* "What it reduces": a chip fills the read panel; the panel keeps the height of its tallest concern. */
  function reduces8(band) {
    band.querySelectorAll('[data-cqs-reduces]').forEach(function (sec) {
      var str = sec.querySelector('[data-r-strings]');
      var panel = sec.querySelector('[data-r-panel]');
      var k = sec.querySelector('[data-r-kicker]'), nm = sec.querySelector('[data-r-name]'), how = sec.querySelector('[data-r-how]');
      var med = sec.querySelector('[data-r-media]'), meth = sec.querySelector('[data-r-method]'), alt = sec.querySelector('[data-r-alt]');
      var chips = Array.prototype.slice.call(sec.querySelectorAll('.cqs-chip'));
      function fill(b) {
        var yes = b.dataset.kind === 'yes';
        panel.classList.toggle('is-no', !yes);
        k.textContent = yes ? str.dataset.kYes : str.dataset.kNo;
        nm.textContent = b.dataset.name;
        how.textContent = b.dataset.how || '';
        var on = (b.dataset.media || '').split(',').map(function (x) { return x.trim(); });
        med.querySelectorAll('li').forEach(function (li) { var a = yes && on.indexOf(li.dataset.i) > -1; li.classList.toggle('is-on', a); var em = li.querySelector('em'); if (em) em.hidden = !a; });
        meth.textContent = yes ? (b.dataset.method ? str.dataset.method + ' ' + b.dataset.method : '') : str.dataset.test;
        if (!yes && b.dataset.url) {
          alt.hidden = false;
          alt.innerHTML = '';
          var a = document.createElement('a'); a.href = b.dataset.url; a.textContent = b.dataset.link; alt.appendChild(a);
        } else alt.hidden = true;
      }
      var swapT = null;
      function pick(b) {
        chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c === b)); });
        /* Round 11: the old answer fades out (120 ms) before the new one fades in; the panel keeps its height. */
        clearTimeout(swapT);
        panel.classList.add('is-out');
        swapT = setTimeout(function () {
          fill(b);
          panel.classList.remove('is-out', 'is-in'); void panel.offsetWidth; panel.classList.add('is-in');
        }, reduce.matches ? 0 : 120);
        /* Phones (round 11): the panel sits right under the "Designed to reduce" chips, so a tap never moves the page;
           only when the panel's top is below the screen does the page glide just enough to show it. */
        if (window.matchMedia('(max-width: 749px)').matches) {
          var pr = panel.getBoundingClientRect();
          if (pr.top > window.innerHeight - 40) glide(window.scrollY + pr.top - window.innerHeight * .6, 320);
          else if (pr.top < 0) glide(window.scrollY + pr.top - 16, 320);
        }
      }
      function reserve() {
        var cur = chips.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; })[0] || chips[0];
        var max = tallest(panel, chips, fill);
        fill(cur);
        panel.style.minHeight = max + 'px';
      }
      sec.addEventListener('click', function (e) { var b = e.target.closest('.cqs-chip'); if (b) pick(b); });
      whenNear(sec, function () { reserve(); onResize(reserve); });
    });
  }

  function radioFor(root, value) {
    var v = norm(value);
    var inputs = root.querySelectorAll('form[action*="/cart/add"] input[type="radio"], .cq-purchase-group input[type="radio"], variant-radios input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) if (norm(inputs[i].value) === v) return inputs[i];
    return null;
  }
  function checkedIn(root, re) {
    var ins = root.querySelectorAll('form[action*="/cart/add"] input[type="radio"]:checked, .cq-purchase-group input[type="radio"]:checked');
    for (var i = 0; i < ins.length; i++) { var g = ins[i].closest('fieldset'); var lg = g && g.querySelector('legend'); if (lg && re.test(lg.textContent)) return norm(ins[i].value); }
    return null;
  }

  /* "Your size": the rows mirror the buy box both ways; published capacity follows the chosen size and level. */
  function sizes8(band, root) {
    band.querySelectorAll('[data-cqs-sizes]').forEach(function (sec) {
      var rows = Array.prototype.slice.call(sec.querySelectorAll('[data-cqs-size]'));
      var cap = sec.querySelector('[data-cqs-cap]');
      var group = sec.querySelector('.cqs-size-tbl'), message = sec.querySelector('[data-cqs-size-set]');
      var purchase = root.querySelector('cq-purchase-options'), pending = null, timer = 0, selection = 0;
      function mark(chosen) {
        rows.forEach(function (r, i) {
          r.setAttribute('aria-checked', String(r === chosen));
          r.setAttribute('tabindex', r === chosen || (!chosen && i === 0) ? '0' : '-1');
        });
      }
      function confirm() {
        if (!pending || !message) return;
        clearTimeout(timer);
        var total = purchase && purchase.purchaseTotal;
        var price = total && total.totalText ? total.totalText.trim() : '';
        var tpl = message.dataset.tpl || 'Size set to [size], [price]';
        if (!price) tpl = tpl.replace(', [price]', '');
        message.textContent = tpl.replace('[size]', pending.dataset.cqsSize).replace('[price]', price);
        message.hidden = false;
        pending = null;
      }
      if (purchase) purchase.addEventListener('cq:purchase-total', confirm);
      /* Round 14 (2026-10-24): the rows are a radio group. Clicks and arrow keys share one selection path: the chosen row
         lights up at once and the buy box follows after that frame is painted (round 12), so a slow variant change never
         delays the answer; the next purchase total supplies the price for the one-line confirmation under the rows. */
      function select(b) {
        mark(b);
        clearTimeout(timer);
        pending = null;
        var id = ++selection, radio = radioFor(root, b.dataset.cqsSize);
        requestAnimationFrame(function () { setTimeout(function () {
          if (id !== selection) return;
          if (message) { pending = b; timer = setTimeout(confirm, 600); }
          if (radio && !radio.checked) radio.click();
          sync();
        }, 0); });
      }
      if (group) group.addEventListener('keydown', function (e) {
        var i = rows.indexOf(e.target.closest('[data-cqs-size]'));
        if (i < 0) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') i = (i + 1) % rows.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') i = (i + rows.length - 1) % rows.length;
        else if (e.key === 'Home') i = 0;
        else if (e.key === 'End') i = rows.length - 1;
        else return;
        e.preventDefault();
        rows[i].focus();
        select(rows[i]);
      });
      var capRows = {}, levels = [], max = 1;
      if (cap) {
        max = +cap.dataset.max || 1;
        levels = cap.dataset.levels.split('|');
        cap.dataset.rows.split('~').filter(Boolean).forEach(function (r) {
          var p = r.split('#'), caps = {};
          (p[2] || '').split('|').filter(Boolean).forEach(function (kv) { var q = kv.split('='); caps[norm(q[0])] = +q[1]; });
          capRows[norm(p[0])] = { name: p[0], flow: p[1], caps: caps };
        });
      }
      function sync() {
        var size = checkedIn(root, /^\s*size/i);
        mark(rows.filter(function (r) { return norm(r.dataset.cqsSize) === size; })[0]);
        if (!cap) return;
        var row = capRows[size] || capRows[Object.keys(capRows)[0]];
        if (!row) return;
        var lvl = checkedIn(root, /^\s*(type|level)/i);
        cap.querySelector('[data-cqs-cap-for]').textContent = row.name + (row.flow ? ', ' + row.flow + ' GPM' : '');
        cap.querySelectorAll('[data-cqs-cap-bars] li').forEach(function (li) {
          var l = norm(li.dataset.level), v = row.caps[l] || 0;
          li.classList.toggle('is-on', l === lvl);
          li.querySelector('.cqs-cap-v').textContent = v.toLocaleString('en-US') + ' gal';
          li.querySelector('.cqs-cap-track span').style.transform = 'scaleX(' + (v / max).toFixed(3) + ')';
        });
      }
      sec.addEventListener('click', function (e) {
        var b = e.target.closest('[data-cqs-size]');
        if (b) {
          select(b);
          return;
        }
        var to = e.target.closest('[data-cqpm-to-buy]');
        if (to) {
          e.preventDefault();
          var group = root.querySelector('.cq-purchase-group') || root.querySelector('.product-info');
          if (group) window.scrollTo({ top: group.getBoundingClientRect().top + window.scrollY - headerBottom() - 24, behavior: reduce.matches ? 'auto' : 'smooth' });
        }
      });
      root.addEventListener('change', function (e) { if (e.target && e.target.type === 'radio') setTimeout(sync, 0); });
      sync();
    });
  }

  /* The info area below the story: real tabs as a left index on desktop (Direction A); phones keep the accordions. */
  function tabsIndex(root) {
    var part = root.querySelector('.pdp-tab-part');
    if (!part) return null;
    part.classList.add('cqs-index');
    return { mq: window.matchMedia('(min-width: 990px)'), part: part, tabs: true };
  }


  /* ===== Round 10 (2026-10-23): intention in the details. One easing curve and a few durations for every
     movement (CSS --cqs-ease); transforms and opacity only; nothing ever takes the scroll away from the shopper. ===== */

  /* The page width without the scrollbar, for edge-to-edge bands (100vw would include a desktop scrollbar). Round 11
     (review D14): measured again whenever the page box changes, including when a classic scrollbar appears after the
     first measure, and once more on load. */
  function pageWidth() {
    var de = document.documentElement;
    var set = function () { var w = de.clientWidth + 'px'; if (de.style.getPropertyValue('--cqs-pw') !== w) de.style.setProperty('--cqs-pw', w); };
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(de);
    window.addEventListener('resize', set);
    window.addEventListener('load', set, { once: true });
  }

  /* What's inside: picking a media line glides the photo to its dish, and a small frosted label on the photo names it
     (round 12: no drawn line). Picking it again, or clicking the photo away from a dish, shows the whole photo.
     Clicking a dish picks its line. */
  function insideZoom(band) {
    band.querySelectorAll('.cqs-inside').forEach(function (sec) {
      var fig = sec.querySelector('[data-cqs-zoomfig]');
      var zoom = fig && fig.querySelector('.cqs-zoom');
      var buttons = Array.prototype.slice.call(sec.querySelectorAll('.cqs-media button[data-zx]'));
      if (!fig || !zoom || !buttons.length) return;
      var S = 1.9, current = null;
      var cap = document.createElement('span');
      cap.className = 'cqs-zoom-cap';
      cap.setAttribute('aria-hidden', 'true');
      cap.innerHTML = '<b></b><span></span>';
      fig.appendChild(cap);
      function place(btn) {
        if (!btn) { zoom.style.transform = ''; fig.classList.remove('is-zoomed'); return; }
        var x = +btn.dataset.zx / 100, y = +btn.dataset.zy / 100;
        var lim = (1 - 1 / S) / 2;
        var tx = Math.max(-lim, Math.min(lim, .5 - x)), ty = Math.max(-lim, Math.min(lim, .5 - y));
        zoom.style.transform = 'scale(' + S + ') translate(' + (tx * 100).toFixed(2) + '%, ' + (ty * 100).toFixed(2) + '%)';
        var n = btn.querySelector('.cqs-media-n');
        var name = Array.prototype.filter.call(btn.childNodes, function (c) { return c !== n; }).map(function (c) { return c.textContent; }).join('').trim();
        fig.classList.remove('is-zoomed');
        void cap.offsetWidth;
        cap.querySelector('b').textContent = n ? n.textContent.trim() : '';
        cap.querySelector('span').textContent = name;
        fig.classList.add('is-zoomed');
      }
      sec.addEventListener('click', function (e) {
        var b = e.target.closest('.cqs-media button[data-zx]');
        if (b) {
          var same = current === b && fig.classList.contains('is-zoomed');
          current = b;
          place(same ? null : b);
          return;
        }
        if (fig.contains(e.target)) {
          if (fig.classList.contains('is-zoomed')) { place(null); return; }
          var r = fig.getBoundingClientRect(), px = (e.clientX - r.left) / r.width * 100, py = (e.clientY - r.top) / r.height * 100;
          var best = null, d = 1e9;
          buttons.forEach(function (bt) { var dd = Math.hypot(+bt.dataset.zx - px, +bt.dataset.zy - py); if (dd < d) { d = dd; best = bt; } });
          if (best && d < 22) best.click();
        }
      });
      onResize(function () { if (current && fig.classList.contains('is-zoomed')) place(current); });
    });
  }

  /* How it's built (round 11): a short pinned frame on desktop with motion on. The picture stays while three steps
     scroll past and crossfades to each step's picture. Phones and reduced motion: one still picture and the steps as a
     list (no pin, CSS shows the entry's own photo). Reading only: the page scrolls as usual. */
  function layers(band) {
    band.querySelectorAll('[data-cqs-layers]').forEach(function (sec) {
      var steps = Array.prototype.slice.call(sec.querySelectorAll('.cqs-lstep'));
      var imgs = {};
      sec.querySelectorAll('.cqs-layer-img').forEach(function (im) { imgs[im.dataset.key] = im; });
      var dots = sec.querySelectorAll('.cqs-layers-dots i');
      if (!steps.length) return;
      var wide = window.matchMedia('(min-width: 990px)');
      var cur = -1, live = false, ticking = false;      function go(i) {
        if (i === cur) return;
        cur = i;
        var key = steps[i].dataset.img || 'layers';
        steps.forEach(function (el, j) { el.classList.toggle('is-on', j === i); });
        Array.prototype.forEach.call(dots, function (dot, j) { dot.classList.toggle('is-on', j === i); });
        Object.keys(imgs).forEach(function (k) { imgs[k].classList.toggle('is-on', k === key); });
      }
      function read() {
        ticking = false;
        if (!sec.classList.contains('is-pinned')) return;
        /* The step in view is the one whose middle is nearest the middle of the picture. */
        var fr = sec.querySelector('.cqs-layers-frame').getBoundingClientRect(), line = (fr.top + fr.bottom) / 2, idx = 0, best = Infinity;
        /* The first idea counts as 160 px nearer, so its picture holds a little longer before the second takes over. */
        steps.forEach(function (el, j) { var r = el.getBoundingClientRect(), d = Math.abs((r.top + r.bottom) / 2 - line) - (j ? 0 : 160); if (d < best) { best = d; idx = j; } });
        go(idx);
      }
      function mode() {
        var pin = wide.matches && !reduce.matches;
        sec.classList.toggle('is-pinned', pin);
        if (pin) {
          cur = -1; read(); if (cur < 0) go(0);
        } else { cur = -1; steps.forEach(function (el) { el.classList.remove('is-on'); }); }
      }
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { live = es[0].isIntersecting; if (live) read(); }).observe(sec);
      window.addEventListener('scroll', function () { if (live && !ticking) { ticking = true; requestAnimationFrame(read); } }, { passive: true });
      if (wide.addEventListener) { wide.addEventListener('change', mode); reduce.addEventListener('change', mode); }
      mode();
      /* Phone swipe cards: a card less than 60 percent in view is dimmed (CSS applies it on phones with motion on). */
      var list = sec.querySelector('.cqs-steps-list');
      if (list && 'IntersectionObserver' in window) {
        var cards = new IntersectionObserver(function (es) {
          es.forEach(function (e) { e.target.classList.toggle('is-dim', e.intersectionRatio < .6); });
        }, { root: list, threshold: [0, .6, 1] });
        steps.forEach(function (el) { cards.observe(el); });
      }
    });
  }

  /* Round 14 (2026-10-24): areas that scroll sideways (the phone swipe cards, wide tables) take keyboard focus while they
     overflow, so they can be scrolled with the arrow keys; each is named by its section's heading. */
  function scrollFocus(scope) {
    var areas = Array.prototype.slice.call(scope.querySelectorAll('.cqs-steps-list, .table-wrapper, .cqs-size-table, .cqd-table-wrap'));
    function set() {
      areas.forEach(function (el) {
        var over = el.scrollWidth > el.clientWidth + 1 && getComputedStyle(el).overflowX !== 'visible';
        if (over && !el.hasAttribute('tabindex')) {
          var h = el.closest('section, .tabcontent, .facet-content, .cqd-sec');
          h = h && h.querySelector('h2, h3');
          /* A list keeps its list role (its items stay list items); other boxes become named regions. */
          el.setAttribute('tabindex', '0');
          if (!/^(UL|OL)$/.test(el.tagName)) el.setAttribute('role', 'region');
          if (h) el.setAttribute('aria-label', h.textContent.trim());
          el.dataset.cqsFocus = '1';
        } else if (!over && el.dataset.cqsFocus) {
          el.removeAttribute('tabindex'); el.removeAttribute('role'); el.removeAttribute('aria-label'); delete el.dataset.cqsFocus;
        }
      });
    }
    set();
    window.addEventListener('load', set, { once: true });
    onResize(set);
    /* A table inside a closed phone accordion or a hidden tab only overflows once it opens. Capture phase: the
       accordion and tab handlers stop the click from reaching listeners further up. */
    scope.addEventListener('click', function (e) { if (e.target.closest('.facet-toggle, .tablinks')) setTimeout(set, 450); }, true);
  }

  /* Headlines and chapter numbers rise into place once as they enter the screen (only with script and motion on). */
  function reveals(band) {
    if (reduce.matches || !('IntersectionObserver' in window)) return;
    var els = band.querySelectorAll('.cqs-head, .cqs-open-txt, .cqs-bleed-in, .cqs-quote figure, .cqs-spot-txt');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -12% 0px' });
    Array.prototype.forEach.call(els, function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * .88 && r.bottom > 0) { el.classList.add('is-in'); return; }
      el.classList.add('cqs-rise');
      io.observe(el);
    });
  }

  function fadeImages(scope) {
    scope.classList.add('is-js');
    scope.querySelectorAll('img').forEach(function (img) {
      if (img.complete && img.naturalWidth) { img.classList.add('is-loaded'); return; }
      img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
      img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
    });
    /* Never leave a picture hidden: anything still waiting after a few seconds simply shows. */
    setTimeout(function () { scope.querySelectorAll('img:not(.is-loaded)').forEach(function (img) { if (img.complete) img.classList.add('is-loaded'); }); }, 4000);
  }

  /* ===== Round 11 (approved by AJ, 2026-10-23): one sticky
     bar per device, an info index that crossfades, chat without its greeting. ===== */
  var EASE = 'cubic-bezier(.22, .61, .36, 1)';

  /* A scroll with an ease and a set duration (native smooth scrolling has no duration). The shopper's own wheel,
     touch or key ends it at once. */
  function glide(to, ms, done) {
    var from = window.scrollY, d = to - from, stop = false, t0 = null;
    /* Round 13: a long trip (more than a screen and a half) moves most of the way at once and glides only the last
       stretch of about half a screen, gently, so the page never whips past its content on the way back up. */
    var near = window.innerHeight * .55;
    if (!reduce.matches && ms && Math.abs(d) > window.innerHeight * 1.5) {
      from = to - (d > 0 ? near : -near);
      window.scrollTo({ top: from, behavior: 'instant' });
      d = to - from; ms = 520;
    }
    /* Short anchors ease out; longer trips (round 12) ease in and out so the page never lurches at the start. */
    var ease = ms > 400 && Math.abs(d) > window.innerHeight * .6 ? function (p) { return p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; } : function (p) { return 1 - Math.pow(1 - p, 4); };
    /* The site sets scroll-behavior: smooth on html, so every step here asks for an instant position. */
    if (reduce.matches || !ms || Math.abs(d) < 2) { if (Math.abs(d) >= 2) window.scrollTo({ top: to, behavior: 'instant' }); if (done) done(); return; }
    var evs = ['wheel', 'touchstart', 'keydown'];
    var cancel = function () { stop = true; };
    evs.forEach(function (ev) { window.addEventListener(ev, cancel, { capture: true, passive: true }); });
    function end() { evs.forEach(function (ev) { window.removeEventListener(ev, cancel, true); }); if (done) done(stop); }
    function step(t) {
      if (stop) { end(); return; }
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / ms);
      window.scrollTo({ top: from + d * ease(p), behavior: 'instant' });
      if (p < 1) requestAnimationFrame(step); else end();
    }
    requestAnimationFrame(step);
  }

  /* The info index (desktop, 990 px and up): Direction A's list down the left with a dot on the open section, sticky
     beside the content, Overview (back to the start of the marketing blocks) as its first row. Round 14 (2026-10-24):
     it is the area's only navigation (no bar at the top), and it sits under the site header, which no longer moves. A
     choice anchors the area's top under the header whenever it is not already there (above or below), then the panels
     crossfade: the old one fades out (200 ms) over the new one, which fades in from 6 px below (280 ms), while the area's
     height glides (320 ms; skipped past 1.5 screens). The dot slides (200 ms). Reduced motion: an instant swap, still
     anchored. A keyboard choice moves focus to the panel heading. Phones and tablets keep the accordions. */
  function tabFade(lp) {
    if (!lp || !lp.part) return;
    var part = lp.part, mq = lp.mq;
    var nav = part.querySelector('.tabs-nav'), box = part.querySelector('.tabs-content');
    var links = Array.prototype.slice.call(part.querySelectorAll('.tablinks'));
    if (!nav || !box || !links.length) return;
    var dot = document.createElement('span');
    dot.className = 'cqs-index-dot';
    dot.setAttribute('aria-hidden', 'true');
    nav.appendChild(dot);
    part.classList.add('has-dot');
    function placeDot(link) {
      var on = link || links.filter(function (l) { return l.getAttribute('aria-selected') === 'true'; })[0];
      if (!on || !mq.matches) return;
      var n = nav.getBoundingClientRect(), r = on.getBoundingClientRect();
      dot.style.transform = 'translateY(' + Math.round(r.top - n.top + r.height / 2 - 4) + 'px)';
    }
    if (lp.band) {
      if (!lp.band.id) lp.band.id = 'cq-product-marketing';
      var overview = document.createElement('a');
      overview.className = 'cqs-index-ov';
      overview.href = '#' + lp.band.id;
      overview.setAttribute('data-cqs-ov', '');
      overview.innerHTML = '<span class="cqs-index-ov-text"></span><svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false"><path d="M8 13V3M3.5 7.5 8 3l4.5 4.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      overview.querySelector('.cqs-index-ov-text').textContent = lp.band.dataset.overview || 'Overview';
      nav.insertBefore(overview, nav.firstChild);
    }
    function headerVar() { document.documentElement.style.setProperty('--cqs-hdr-h', hdrH() + 'px'); }
    lp.rowTop = function () { return part.getBoundingClientRect().top + window.scrollY - hdrH(); };
    whenNear(part, function () { headerVar(); placeDot(); onResize(function () { placeDot(); headerVar(); }); });
    /* Round 14 (2026-10-24): the dot also follows the tabs script's own keyboard choices and direct tab changes. */
    part.addEventListener('keydown', function (e) {
      if (e.target.closest('.tablinks') && /^(ArrowRight|ArrowLeft|Home|End)$/.test(e.key)) setTimeout(function () { placeDot(); }, 0);
    });
    part.addEventListener('click', function (e) {
      if (e.target.closest('.tablinks')) { placeDot(); return; }
      if (!e.target.closest('[data-cqs-ov]')) return;
      e.preventDefault();
      if (lp.goOverview) lp.goOverview();
    });
    var busy = false;
    function commit(link) { link.dataset.cqsPass = '1'; link.click(); delete link.dataset.cqsPass; }
    function swap(link, from, to, kb) {
      function done() {
        [from, to].forEach(function (p) { if (p) p.style.cssText = ''; });
        box.style.height = ''; box.style.transition = ''; box.style.position = ''; box.style.overflow = '';
        placeDot(); busy = false;
        if (kb) { var h = to.querySelector('h2, h3'); if (h) { if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); } }
      }
      if (reduce.matches || !from) { commit(link); setTimeout(done, 0); return; }
      /* Round 12: a true crossfade. A still copy of the old panel sits on top and fades out while the new panel fades
         in under it, so the area is never empty; the height glides between the two. Frames and scripts stay out of
         the copy (a reviews widget would reload). */
      var h0 = box.offsetHeight;
      var ghost = from.cloneNode(true);
      ghost.removeAttribute('id');
      ghost.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
      ghost.querySelectorAll('iframe, script, video').forEach(function (n) { n.remove(); });
      ghost.setAttribute('aria-hidden', 'true');
      ghost.inert = true;
      ghost.style.cssText = 'position:absolute;left:0;right:0;top:0;margin:0;pointer-events:none;opacity:1;transition:opacity 200ms cubic-bezier(.4, 0, 1, 1)';
      box.style.height = h0 + 'px'; box.style.position = 'relative'; box.style.overflow = 'hidden';
      box.appendChild(ghost);
      commit(link);
      /* If the theme did not switch (nothing to fade to), finish at once rather than show two states. */
      if (to.hidden || getComputedStyle(to).display === 'none') { ghost.remove(); done(); return; }
      to.style.opacity = '0'; to.style.transform = 'translateY(6px)';
      var h1 = to.offsetHeight;
      void to.offsetWidth;
      placeDot(link);
      var big = Math.abs(h1 - h0) > window.innerHeight * 1.5;
      requestAnimationFrame(function () {
        ghost.style.opacity = '0';
        to.style.transition = 'opacity 280ms ' + EASE + ' 40ms, transform 360ms ' + EASE + ' 40ms';
        to.style.opacity = '1'; to.style.transform = 'none';
        box.style.transition = big ? 'none' : 'height 320ms ' + EASE;
        box.style.height = h1 + 'px';
      });
      /* If the new panel grew while it faded in (late tables or pictures), the height glides on to it before it is
         released, so the page never jumps at the end. */
      setTimeout(function () {
        ghost.remove();
        var hn = to.offsetHeight;
        if (big || Math.abs(hn - box.offsetHeight) < 4) { done(); return; }
        box.style.transition = 'height 220ms ' + EASE;
        box.style.height = hn + 'px';
        setTimeout(done, 240);
      }, 420);
    }
    part.addEventListener('click', function (e) {
      var link = e.target.closest('.tablinks');
      if (!link || !mq.matches || link.dataset.cqsPass) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (busy) return;
      var kb = e.detail === 0;
      var from = part.querySelector('.tabcontent:not([hidden])');
      var to = document.getElementById(link.getAttribute('aria-controls') || link.dataset.tab);
      var same = link.getAttribute('aria-selected') === 'true';
      var top = part.getBoundingClientRect().top, off = hdrH();
      busy = true;
      /* Round 13: the panels change the moment the tab is clicked, and the area glides to its top under the header at
         the same time whenever it is not already there (above or below), so every tab opens at its start. */
      var anchor = Math.abs(top - off) > 2;
      if (anchor) glide(window.scrollY + top - off, Math.round(Math.min(620, Math.max(380, 300 + Math.abs(top - off) * .3))));
      if (same || !to || to === from) { setTimeout(function () { busy = false; }, anchor ? 360 : 0); return; }
      /* Outside this click: a browser ignores a second click() on a tab whose own click is still running. */
      setTimeout(function () { swap(link, from, to, kb); }, 0);
    }, true);
    return { open: function (link) { link.click(); } };
  }

  /* The page bars (bottom bar, Sections sheet, header on phones) are the same on every product page
     (assets/cq-product-bar.js); a story page starts them with its Overview and its desktop index, then uses their
     scroll helpers: the hero card's buttons open the matching info section, and an opened phone or tablet section
     glides below the site header. */
  function storyBars(band, root, lp) {
    var bars = window.cqProductBar && window.cqProductBar.start({
      root: root, lp: lp, overview: band.dataset.overview,
      overviewEl: function () { return band.querySelector('.cqs-open, section'); }
    });
    if (!bars) return;
    if (lp) lp.goOverview = bars.goOverview;
    band.addEventListener('click', function (e) {
      var j = e.target.closest('[data-cqpm-jump]');
      if (j && bars.goInfoBy(j.dataset.cqpmJump === 'compat' ? /compatib/i : /specification/i)) e.preventDefault();
    });
    var info = window.matchMedia('(min-width: 990px)');
    root.addEventListener('click', function (e) {
      var l = e.target.closest('.tablinks, .facet-toggle');
      if (!l) return;
      if (!info.matches && l.classList.contains('facet-toggle') && l.getAttribute('aria-expanded') !== 'true') {
        setTimeout(function () {
          if (l.getAttribute('aria-expanded') === 'true' && Math.abs(l.getBoundingClientRect().top - hdrH() - 16) > 2) bars.scrollToEl(l);
        }, 60);
      }
      setTimeout(bars.queue, 920);
    }, true);
  }

  /* Phone and tablet info accordions (under 990 px): the same recipe as the desktop tabs (review section 5). Opening:
     the theme opens the section, then its height glides from 0 (240 ms) while the content fades in from 8 px below
     (200 ms, from 60 ms). Closing: the content fades out (120 ms) while the height glides to 0, then the theme closes
     it. Round 14 (2026-10-24): a section taller than 1.5 screens glides too, over its first screen only; the rest is
     added or removed below the fold, out of sight, so no section snaps open or shut. Reduced motion: instant. */
  function accordions11(root) {
    var mq = window.matchMedia('(max-width: 989px)');
    root.querySelectorAll('.product-info-description-mobile collapsible-expandable').forEach(function (ce) {
      var content = ce.querySelector('.facet-content');
      if (!content || !ce.querySelector('.facet-toggle')) return;
      var busy = false;
      function clean() { content.style.height = ''; content.style.overflow = ''; content.style.opacity = ''; content.style.transform = ''; content.style.transition = ''; busy = false; }
      ce.addEventListener('click', function (e) {
        if (!e.target.closest('.facet-toggle') || !mq.matches || reduce.matches) return;
        if (busy) { e.preventDefault(); e.stopImmediatePropagation(); return; }
        if (ce.getAttribute('expanded') === 'true') {
          var h = content.offsetHeight;
          if (!h || typeof ce.collapse !== 'function') return;
          e.preventDefault();
          e.stopImmediatePropagation();
          busy = true;
          /* A tall section starts from the part still on screen; the cut below the fold is not seen. */
          var seen = Math.max(0, window.innerHeight - content.getBoundingClientRect().top) + 40;
          content.style.overflow = 'hidden';
          content.style.height = Math.min(h, seen) + 'px';
          void content.offsetHeight;
          content.style.transition = 'height 240ms ' + EASE + ', opacity 120ms cubic-bezier(.4, 0, 1, 1)';
          content.style.height = '0px';
          content.style.opacity = '0';
          setTimeout(function () { ce.collapse(); clean(); }, 250);
        } else {
          if (typeof ce.expand !== 'function') return;
          /* Open it here, with the start state set in the same task, so the section never paints fully open first. */
          e.preventDefault();
          e.stopImmediatePropagation();
          busy = true;
          content.style.overflow = 'hidden';
          content.style.height = '0px';
          content.style.opacity = '0';
          content.style.transform = 'translateY(8px)';
          ce.expand();
          if (ce.shouldCollapseOthers && typeof ce.collapseOthers === 'function') ce.collapseOthers();
          var h1 = content.scrollHeight;
          var big = h1 > window.innerHeight * 1.5;
          void content.offsetHeight;
          content.style.transition = 'height 240ms ' + EASE + ', opacity 200ms ' + EASE + ' 60ms, transform 200ms ' + EASE + ' 60ms';
          content.style.height = (big ? Math.round(window.innerHeight) : h1) + 'px';
          content.style.opacity = '1';
          content.style.transform = 'none';
          setTimeout(clean, 300);
        }
      }, true);
    });
  }

  function init() {
    var band = document.querySelector('[data-cq-product-marketing]');
    if (!band || band.dataset.cqpmReady) return;
    band.dataset.cqpmReady = '1';
    fadeImages(band);
    var compat = document.getElementById('cqpm-compat');
    if (compat) fadeImages(compat);
    var root = band.closest('.product-info-wrap') || band.parentNode || document;
    var page = band.querySelector('[data-cqpm-page]');
    compares(band);
    pageWidth(); accordion8(band); insideZoom(band); layers(band); reveals(band); reduces8(band); sizes8(band, root);
    if (page) styleDescription(root, band, page);
    /* The info index (the story supplies Overview, its first row), the phone accordions and the page bars. */
    var lp = tabsIndex(root);
    if (lp) lp.band = band;
    tabFade(lp);
    accordions11(root);
    storyBars(band, root, lp);
    scrollFocus(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
